module.exports = __webpack_public_path__ + "img/faq1.f3b9d7e9.png";